import React, { FunctionComponent, ReactNode } from 'react'
import clsx from 'clsx'
import { DDPrivacyLevel } from '../../datadog'
import styles from './style.module.css'

type StylingModifier = 'wrap' | 'margin'

interface MaskedElementProps {
  privacyLevel?: DDPrivacyLevel
  actionName?: string
  stylingModifier?: StylingModifier
  children: ReactNode
  testNameSpace?: string
}

const getModifierClassName = (modifier?: StylingModifier): string | null => {
  const map: Record<StylingModifier, string> = {
    wrap: styles.inputWrapper,
    margin: styles.marginInBetween,
  }
  return modifier ? map[modifier] ?? '' : null
}

export const MaskedElement: FunctionComponent<MaskedElementProps> = ({
  privacyLevel = DDPrivacyLevel.Mask,
  actionName = 'Masked Element',
  stylingModifier,
  children,
  testNameSpace = 'masked-element',
}) => {
  const cls = clsx(getModifierClassName(stylingModifier))
  return (
    <div
      className={cls}
      data-dd-privacy={privacyLevel}
      data-dd-action-name={privacyLevel === DDPrivacyLevel.Allow ? undefined : actionName}
      data-testid={testNameSpace}
    >
      {children}
    </div>
  )
}
